import { render, staticRenderFns } from "./aboutinfo.vue?vue&type=template&id=cd8a08b4&scoped=true"
import script from "./aboutinfo.vue?vue&type=script&lang=js"
export * from "./aboutinfo.vue?vue&type=script&lang=js"
import style0 from "./aboutinfo.vue?vue&type=style&index=0&id=cd8a08b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8a08b4",
  null
  
)

export default component.exports